import { createReducer, on } from '@ngrx/store';
import * as fromAuthActions from './auth.actions';
import { AuthenticationResult } from '@qvs/core';

export const authFeatureKey = 'auth';

export interface State {
  authenticationResult: AuthenticationResult;
  consentAccepted: boolean;
  hasError: boolean;
  isLoading: boolean;
  isLoadingUserProfile: boolean;
  contractNumber?: string;
  isAuthenticationInProgress?: boolean;
  isAuthenticationApproved?: boolean;
  isAuthenticatedInAppSuccess?: boolean;
  isAccessAppUnavailable?: boolean;
  authenticatedAt?: number;
}

export const initialState: State = {
  authenticationResult: {
    isAuthenticated: false
  },
  consentAccepted: false,
  hasError: false,
  isLoading: false,
  isAuthenticationInProgress: false,
  isAuthenticationApproved: false,
  isLoadingUserProfile: false,
  isAuthenticatedInAppSuccess: false
};

export const reducer = createReducer(
  initialState,
  on(fromAuthActions.acceptConsent, (state, action) => ({
    ...state,
    consentAccepted: true
  })),
  on(fromAuthActions.cancelConsent, (state, action) => ({
    ...state,
    authenticationResult: {
      isAuthenticated: false
    },
    authenticatedAt: undefined,
    consentAccepted: false,
    hasError: false,
    isLoading: false,
    isLoadingUserProfile: false
  })),
  on(fromAuthActions.logoutFailure, fromAuthActions.logoutSuccess, (state) => ({
    ...state,
    authenticationResult: initialState.authenticationResult,
    authenticatedAt: undefined,
    hasError: false,
    isLoading: false,
    isAuthenticationInProgress: false,
    isAuthenticationApproved: false,
    isLoadingUserProfile: false,
    isAuthenticatedInAppSuccess: false
  })),
  on(fromAuthActions.redirectedAfterAuthentication, (state, action) => ({
    ...state,
    isLoading: true,
    isLoadingUserProfile: true
  })),
  on(fromAuthActions.redirectedAfterAuthenticationSuccess, (state, action) => ({
    ...state,
    hasError: false,
    isLoading: false,
    isAuthenticationInProgress: false,
    isAuthenticationApproved: false,
    isLoadingUserProfile: false,
    isAuthenticatedInAppSuccess: false
  })),
  on(fromAuthActions.createAuthenticationSuccess, (state, action) => ({
    ...state,
    authenticationResult: {
      ...state.authenticationResult,
      ...action.authenticationResult
    },
    contractNumber: action.contractNumber ?? state.contractNumber,
    authenticatedAt: action.authenticatedAt
  })),
  on(fromAuthActions.createAuthenticationResultSuccess, (state, action) => ({
    ...state,
    // TODO 09-Jun-2026/braune: this flag should probably be having a different name (or be set with the action above)
    isAuthenticationApproved: true,
    authenticationResult: {
      ...state.authenticationResult,
      ...action.authenticationResult
    }
  })),
  on(fromAuthActions.createAuthenticationFromAccessAppSuccess, (state, action) => ({
    ...state,
    authenticationResult: {
      ...state.authenticationResult,
      isAccessAppAuthenticationSuccess: true
    }
  })),
  on(fromAuthActions.authenticateByContractNumber, (state, action) => ({
    ...state,
    authenticationResult: {
      isAuthenticated: false
    },
    hasError: false,
    isLoading: true,
    isAuthenticationInProgress: true,
    contractNumber: action.contractNumber
  })),
  on(fromAuthActions.authenticateByContractNumberFailure, (state, action) => ({
    ...state,
    authenticationResult: action.authenticationResult ?? {
      ...state.authenticationResult,
      isServerError: true
    },
    hasError: true,
    isLoading: false,
    isAuthenticationInProgress: false,
    isAuthenticationApproved: false,
    isLoadingUserProfile: false,
    isAuthenticatedInAppSuccess: false
  })),
  on(fromAuthActions.accessAppIsUnavailable, (state) => ({
    ...state,
    isAccessAppUnavailable: true
  }))
);
